import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';
import Icon from '../Icon';
import styles from './FacetsMobileBtn.module.less';

const FacetsMobileBtn = ({ onClick }) => {
  return (
    <div className={styles.container}>
      <Button className={styles.button} color="tertiary" onClick={onClick}>
        <Icon name="plus-circled" className={styles.plusIcon} />
        Filters
      </Button>
    </div>
  );
};

FacetsMobileBtn.propTypes = {
  onClick: PropTypes.func,
};

export default FacetsMobileBtn;
